import(/* webpackMode: "eager" */ "/home/tsagi/build/test/web-dist/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/tsagi/build/test/web-dist/src/assets/loading.svg");
